svg {
  fill: currentColor;
}
